import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback, useState } from 'react';
import FormGroup from '@enquiryForm/components/FormGroup';
import FormError from '@enquiryForm/components/FormError';
import { useContext, useRef } from 'preact/compat';
import API from '@widgets/shared/API/connection';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { overrideNotices } from '@basket/store/actions/notices';
import { useAppDispatch } from '@basket/store/hooks';
import { format } from 'date-fns';
import GiftVoucherModal from '@basket/components/GiftVoucherModal';
import { ConfigCTX } from '@basket/context/config';
import { Copy, Details, PromoWrapper, Summary, Title, Wrapper, } from './styles';
const checkVoucherCode = AwesomeDebouncePromise(API.checkVoucherCode, 500);
function PromoCode(props) {
    const { title, copy, total } = props;
    const [couponCode, setCouponCode] = useState('');
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [giftVoucherModalOpen, setGiftVoucherModalOpen] = useState(false);
    const [giftVoucher, setGiftVoucher] = useState(undefined);
    const inputRef = useRef(null);
    const { isModal, basketPage } = useContext(ConfigCTX);
    const dispatch = useAppDispatch();
    const handleGiftVoucherOpen = useCallback(() => setGiftVoucherModalOpen(true), [setGiftVoucherModalOpen]);
    const handleGiftVoucherClose = useCallback(() => setGiftVoucherModalOpen(false), [setGiftVoucherModalOpen]);
    const submitVoucher = useCallback(() => {
        checkVoucherCode(couponCode)
            .then((res) => {
            const { Message, isGiftCard, success,
            // giftCardExpires,
            // giftCardBalance,
             } = res;
            // is a gift code
            const isGiftCode = success && isGiftCard;
            const isPromoCode = success && !isGiftCard;
            if (!success) {
                setIsError(isError);
                setErrorMessage(res.Message);
                dispatch(overrideNotices([
                    {
                        id: 'voucher-error',
                        message: Message,
                        level: 'error',
                    },
                ]));
            }
            else if (isGiftCode) {
                const { giftCardExpires, giftCardBalance } = res;
                setGiftVoucher({
                    giftCardBalance: giftCardBalance ?? 0.00,
                    giftCardExpires: giftCardExpires ?? format(Date.now(), 'yyyy-MM-d'),
                    coupon: couponCode ?? '',
                });
                handleGiftVoucherOpen();
            }
            else if (isPromoCode) {
                const basketResponse = res;
                console.log('Basket Response: ', basketResponse);
                window.dispatchEvent(new CustomEvent('basket.modify', {
                    detail: basketResponse,
                }));
                dispatch(overrideNotices([
                    {
                        id: 'promo-code',
                        message: 'Promo code has been applied successfully',
                        level: 'success',
                    },
                ]));
            }
            if (inputRef) {
                inputRef.current?.blur();
            }
        });
    }, [couponCode]);
    const formSubmit = (e) => {
        e.preventDefault();
        submitVoucher();
    };
    return (_jsxs(Wrapper, { className: "basket__promo", children: [(giftVoucherModalOpen && giftVoucher) && (_jsx(GiftVoucherModal, { ...giftVoucher, onClose: () => handleGiftVoucherClose(), maxValue: Math.min(total, giftVoucher.giftCardBalance) })), _jsxs(Details, { children: [_jsxs(Summary, { children: [_jsx(Title, { className: "h4", children: title }), copy && _jsx(Copy, { children: copy })] }), _jsx("form", { onSubmit: formSubmit, className: "form", children: _jsxs(FormGroup, { className: isError ? 'form__group--error' : '', children: [_jsx("label", { htmlFor: "coupon__code", className: "sr-only", children: "Gift Voucher or Promo Code" }), _jsxs(PromoWrapper, { children: [_jsx("input", { type: "text", name: "coupon", id: "coupon__code", placeholder: "Gift Voucher or Promo Code", className: "form__control", ref: inputRef, onChange: (e) => {
                                                const target = e.target;
                                                setCouponCode(target.value.toUpperCase());
                                            }, onFocus: (e) => {
                                                const target = e.target;
                                                if (isError && errorMessage) {
                                                    setCouponCode('');
                                                    setErrorMessage('');
                                                    setIsError(false);
                                                }
                                            }, value: couponCode }), _jsx("button", { className: "btn", type: "submit", children: "Submit" })] }), isError && errorMessage && _jsx(FormError, { children: errorMessage })] }) })] })] }));
}
PromoCode.defaultProps = {
    copy: undefined,
};
export default PromoCode;
